/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_LabelInputs */

const en_fc_online_label = /** @type {(inputs: Fc_Online_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use online`)
};

/**
* | output |
* | --- |
* | "Use online" |
*
* @param {Fc_Online_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_label = /** @type {((inputs?: Fc_Online_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_label(inputs)
});
export { fc_online_label as "fc.online.label" }